import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from 'src/app/constants';
import { PalleteTypeService } from 'src/app/service/asn/pallet-type.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ExportStateService } from 'src/app/service/export-state.service';

@Component({
  selector: 'app-add-pallet-data',
  templateUrl: './add-pallet-data.component.html',
  styleUrls: ['./add-pallet-data.component.scss'],
  standalone: false
})
export class AddPalletDataComponent implements OnInit {

  heading: string;
  errormsg: string;
  eventType: string;
  weightUOM
  dimension
  country
  currency
  basePrice
  weight
  width
  length
  height
  description
  type
  userId: any;
  constructor(public dialogRef: MatDialogRef<AddPalletDataComponent>, private readonly constants: Constants,
    @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly palletType: PalleteTypeService,
    private readonly exportStateService: ExportStateService, private readonly ngxUiLoaderService: NgxUiLoaderService) { }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.eventType = this.dataStore.eventType
    if (this.eventType == 'EDIT') { // NOSONAR
      this.type = this.dataStore.type
      this.description = this.dataStore.description
      this.length = this.dataStore.length
      this.width = this.dataStore.width
      this.height = this.dataStore.height
      this.weight = this.dataStore.weight
      this.basePrice = this.dataStore.basePrice
      this.currency = this.dataStore.currency
      this.country = this.dataStore.country
      this.dimension = this.dataStore.dimension
      this.weightUOM = this.dataStore.weightUOM
    }
  }
  close(): void {
    this.dialogRef.close(
      { event: 'CloseEvent' }
    );
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  public saveClick(): void {
    this.errormsg = ""
    this.height = this.ifNullSetZero(this.height);
    this.weight = this.ifNullSetZero(this.weight);
    this.length = this.ifNullSetZero(this.length);
    this.width = this.ifNullSetZero(this.width);
    this.basePrice = this.ifNullSetZero(this.basePrice);
    if (this.isValueOk(this.currency)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.country)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.type)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.description)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.dimension)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.weightUOM)) {
      this.showError(this.constants.formInputError);
    } else if (this.weight?.toString().split(".").length > 2 || this.height?.toString().split(".").length > 2) {
      this.showError("invalid decimal");
    } else if (this.basePrice?.toString().split(".").length > 2 || this.length?.toString().split(".").length > 2 || this.width?.toString().split(".").length > 2) {
      this.showError("invalid decimal");
    } else {
      this.saveAPICall();
    }
  }

  saveAPICall(): void { // NOSONAR

    const userData = sessionStorage?.getItem('FGA');
    if (userData) {
      this.userId = JSON.parse(userData)?.user?.userPrincipalName;
    }

    this.errormsg = ""
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    const updateObject = {
      type: this.type,
      description: this.description,
      height: this.formatToDecimal(this.height, 3),
      length: this.formatToDecimal(this.length, 3),
      width: this.formatToDecimal(this.width, 3),
      weight: this.formatToDecimal(this.weight, 3),
      basePrice: this.formatToDecimal(this.basePrice, 2),
      country: this.country,
      currency: this.currency,
      dimension: this.dimension,
      weightUOM: this.weightUOM,
      createdById: this.userId,
      createdBy: JSON.parse(userData)?.user?.firstName
    }
    if (this.eventType == "ADD") { // NOSONAR
      this.palletType.addPalletType(updateObject).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response == "Success") { // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
            });
          } else {
            this.showError(response);
          }
        }, _error => {
          this.showError(this.constants.APIErrorMessage);

        });

    }
    else if (this.eventType == "EDIT") { // NOSONAR
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)

      this.palletType.updatePalletType(updateObject).subscribe(
        response => {
          if (response == "Success") { // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
            });
          } else {
            this.showError(this.constants.APIErrorMessage);
          }

        }, _error => {
          this.showError(this.constants.APIErrorMessage);
        });
    }

  }

  formatToDecimal(value: any, decimalPlaces: number): any {
    if (value == '' || value == undefined || value == null) { // NOSONAR
      return 0;
    }

    const stringValue = value.toString();

    if (!stringValue.includes('.')) {
      return Number(stringValue);
    }

    const [integerPart, decimalPart] = stringValue.split('.');

    return Number(
      integerPart + '.' + decimalPart.substring(0, decimalPlaces)
    );
  }


  validate(event: any, module) {
    const t = event.target.value;
    if (module == "base_price") { // NOSONAR
      event.target.value =
        t.indexOf('.') >= 0 ? t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 3) : t;
    } else if (module == "weight") { // NOSONAR
      event.target.value =
        t.indexOf('.') >= 0 ? t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 4) : t;
    }
  }

  keyPressAlphaNumeric(event) {
    const inp = String.fromCharCode(event.keyCode);
    if (/[.0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  showError(message): void {
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTimeShort);
  }

  isValueOk(param: any): boolean {
    if (param == undefined || param == null || param == "") { return true; } // NOSONAR
    return false;
  }

  ifNullSetZero(param) {
    return Number(param ? param : 0);

  }

}
